import {ofType} from 'redux-observable';
import {concat, merge, Observable, of} from 'rxjs';
import i18next from 'i18next';
import {catchError, mergeMap} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import ChildApi from 'web-app/api/child-api';
import {fetchBasicChildInfoObservable} from 'web-app/react/entities/children/epics';
import * as MoveSettingActions from 'web-app/react/profile/child-profile/move-setting/actions';

import * as Actions from './actions';

const updateStartLeave = action$ =>
    action$.pipe(
        ofType(Actions.updateStartLeave.type),
        mergeMap(({payload}: ReturnType<typeof Actions.updateStartLeave.action>) =>
            Observable.zip(
                of(payload.childId),
                payload.startDate || payload.endDate
                    ? ChildApi.changeStartAndEndDates(
                          payload.childId,
                          payload.startDate,
                          payload.endDate,
                          payload.leavingReason,
                      )
                    : of({}),
            ),
        ),
        mergeMap(([childId, ...successActions]) =>
            concat(
                ...successActions.filter(a => a.type).map(a => of(a)),
                fetchBasicChildInfoObservable(childId),
                of(GlobalEventActions.updateSuccess.action(i18next.t('childProfile.startLeaveUpdated'))),
                of(Actions.updateStartLeaveSuccess.action()),
            ),
        ),
    );

const closeMoveSettingModal = action$ =>
    action$.pipe(
        ofType(MoveSettingActions.moveSettingSuccess.type),
        mergeMap(({payload}: ReturnType<typeof MoveSettingActions.moveSettingSuccess.action>) =>
            merge(fetchBasicChildInfoObservable(payload.childId), of(Actions.setShowSettingMoveModal.action(false))),
        ),
    );

const cancelChildMove = action$ =>
    action$.pipe(
        ofType(Actions.cancelChildMove.type),
        mergeMap(({payload}: ReturnType<typeof Actions.cancelChildMove.action>) =>
            Observable.zip(Observable.of(payload.childId), ChildApi.cancelMoveChildInstitution(payload.childId)),
        ),
        mergeMap(([childId]) =>
            Observable.merge(
                fetchBasicChildInfoObservable(childId),
                Observable.of(Actions.cancelChildMoveSuccess.action()),
                Observable.of(GlobalEventActions.updateSuccess.action(i18next.t('childProfile.settingMoveCancelled'))),
            ),
        ),
        catchError(e => Observable.of(Actions.cancelChildMoveFailed.action(e))),
    );

export default combineEpics(updateStartLeave, closeMoveSettingModal, cancelChildMove);
